import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography, breakpoints }: Theme) =>
  createStyles({
    container: {
      marginTop: 46,

      '& .MuiOutlinedInput-adornedStart': {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    tooltipContainer: {
      position: 'relative',
    },
    tooltipContent: {
      position: 'absolute',
      zIndex: 10,
      left: 720,
      top: 24,
      [breakpoints.down(1420)]: {
        left: 520,
      },
      [breakpoints.down(1250)]: {
        left: 484,
      },
      [breakpoints.down(1150)]: {
        left: 410,
      },
      [breakpoints.down(990)]: {
        left: 320,
      },
    },
    buttons: {
      margin: '40px auto',

      '& .MuiButtonBase-root': {
        fontFamily: 'Roboto',
        minWidth: 112,
        padding: 6,
        margin: '0 8px',
        fontSize: 12,
        fontWeight: typography.fontWeightMedium,
        borderRadius: 4,
      },
    },
    buttonCancel: {
      border: `1px solid ${palette.gray}`,
      color: palette.gray,
    },
    buttonConfirm: {
      border: `1px solid ${palette.green}`,
      backgroundColor: palette.green,
      color: palette.white,
    },

    sectionTitle: {
      margin: '32px 8px 16px',
      fontSize: 14,
    },

    formGroup: {
      margin: '32px 0 0 16px',
    },
    formLabel: {
      marginTop: 5,
      marginBottom: 5,
    },

    alert: {
      maxWidth: 600,
      margin: '40px auto',
      fontSize: 12,
      width: 'fit-content',

      '& b': {
        fontWeight: 900,
      },
    },
    switchText: { fontSize: 12, fontWeight: 500 },
    switchContainer: {
      padding: '0 0 15px 15px',
    },
    securityGroup: {
      paddingLeft: 5,
      '& .MuiInputBase-input.Mui-disabled': {
        height: 45,
      },
    },

    mfaButton: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      color: palette.white,
    },
    mfaButtonYellow: {
      backgroundColor: palette.navCompanyContextActions,
      '&:hover': {
        backgroundColor: palette.navCompanyContextActions,
        color: palette.white,
      },
    },
    mfaButtonGreen: {
      backgroundColor: palette.navAdminActions,
      '&:hover': {
        backgroundColor: palette.navAdminActions,
        color: palette.white,
      },
    },
    mfaButtonBlue: {
      backgroundColor: palette.navOperatorActions,
      '&:hover': {
        backgroundColor: palette.navOperatorActions,
        color: palette.white,
      },
    },
    mfaButtonGray: {
      backgroundColor: palette.navSuperAdminActions,
      '&:hover': {
        backgroundColor: palette.navSuperAdminActions,
        color: palette.white,
      },
    },
    profilePathField: { marginLeft: 5 },
    sectionTitleObs: {
      margin: '32px 8px 16px',
      fontSize: 14,
      alignItems: 'flex-start',
      display: 'flex',
    },
    observationsGrid: { '& .MuiOutlinedInput-root': { height: 'auto' } },
    text: {
      fontSize: 12,
      alignItems: 'center',
      display: 'flex',
    },
    boxInfo: { marginLeft: 4 },
    accessButton: {
      margin: '8px 0px 0px 0px',
      border: `1px solid ${palette.blue}`,
      color: palette.blue,
    },
    infoIcon: {
      color: palette.grey500,
      fontSize: 16,
      marginLeft: 8,
      cursor: 'pointer',
    },
    formLicenseSwitch: { margin: '0px 0px 8px 8px' },
    currentPin: {
      marginRight: 4,
      '& .MuiOutlinedInput-input': { textAlign: 'center' },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        color: palette.deepBlue,
      },
      '& .MuiOutlinedInput-root': { color: palette.deepBlue, fontWeight: 500 },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.deepBlue,
        border: `2px solid ${palette.deepBlue}`,
      },
      '& .MuiFormControl-root': { width: '100%' },
    },
    deviceValidationContainer: { marginLeft: 8 },
    switchChecked: {
      '&.Mui-checked': {
        color: palette.green,

        '& + .MuiSwitch-track': {
          backgroundColor: palette.green,
        },
      },
    },
  });
